/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Pill_StripeInputs */

const en_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const es_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const fr_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const de_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const ja_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const zh_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const ar_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const id_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const it_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const ru_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const pt_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

const ko_home_pill_stripe = /** @type {(inputs: Home_Pill_StripeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe Connect`)
};

/**
* | output |
* | --- |
* | "Stripe Connect" |
*
* @param {Home_Pill_StripeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_pill_stripe = /** @type {((inputs?: Home_Pill_StripeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pill_StripeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_pill_stripe(inputs)
	if (locale === "es") return es_home_pill_stripe(inputs)
	if (locale === "fr") return fr_home_pill_stripe(inputs)
	if (locale === "de") return de_home_pill_stripe(inputs)
	if (locale === "ja") return ja_home_pill_stripe(inputs)
	if (locale === "zh") return zh_home_pill_stripe(inputs)
	if (locale === "ar") return ar_home_pill_stripe(inputs)
	if (locale === "id") return id_home_pill_stripe(inputs)
	if (locale === "it") return it_home_pill_stripe(inputs)
	if (locale === "ru") return ru_home_pill_stripe(inputs)
	if (locale === "pt") return pt_home_pill_stripe(inputs)
	return ko_home_pill_stripe(inputs)
});